import { IUserProfile, IUserStatus } from '../../types/user';
import { Api, ApiActivity, ApiActivityV2 } from '../api';

export async function GetUserProfile(): Promise<IUserProfile> {
    try {
        const request = await Api.get('user/me');

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function GetAllUsers(): Promise<IUserProfile[]> {
    try {
        const request = await Api.get('users');

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function GetUserStatus(): Promise<IUserStatus[]> {
    try {
        const request = await ApiActivityV2.get('activity');

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function StartUserActivity(activity: string) {
    try {
        const request = await ApiActivity.post(`activity/${activity}/start`, {});

        return request.data;
    } catch (error: any) {
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}

export async function EndUserActivity(activity: string, body?: any) {
    try {
        const request = await ApiActivity.post(`activity/${activity}/end`, body || {});

        return request.data;
    } catch (error: any) {
        console.error(error);
        if (error.response && error.response.data.error) {
            throw new Error(error.response.data.error);
        }
        throw error;
    }
}
